import { render, staticRenderFns } from "./BugForTask.vue?vue&type=template&id=39b22844&scoped=true&"
import script from "./BugForTask.vue?vue&type=script&lang=js&"
export * from "./BugForTask.vue?vue&type=script&lang=js&"
import style0 from "./BugForTask.vue?vue&type=style&index=0&id=39b22844&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b22844",
  null
  
)

export default component.exports